<template>
	<v-layout wrap>
		<v-flex xs12 sm12 md12 lg10 offset-lg1>
			<w-list :columns="columns" :items="data" :actions="actions" :loading="loading" @action="invokeAction">
			</w-list>
			<Dialog ref="Dialog" @data="DialogData"></Dialog>
		</v-flex>
		<v-btn color="red" fixed bottom right fab dark @click="createNewItem"><v-icon>mdi-plus</v-icon></v-btn>
		<v-flex xs12 class="text-center" v-show="totalPages && totalPages > 1">
			<v-pagination :length="totalPages" v-model="currentPage" :total-visible="6" class="mt-2"></v-pagination>
		</v-flex>
		<w-message-box v-bind="messageBox" @action="deleteListItem">Naozaj si prajete vymazať položku<br><b>{{ messageBox.text }}</b>&nbsp;?</w-message-box>
	</v-layout>
</template>
<script>
import depotsStoreInit from '@/store/depots/list'
import uuid from '@/mixins/uuid'

import Dialog from './Dialog'
import { mapState } from 'vuex'

export default {
	mixins: [ uuid ],
	data () {
		return {
			columns: [{
				headerText: 'Názov',
				value: 'name'
			}],
			actions: [
				// { name: 'edit', text: this.$i18n.translate('Edit'), icon: 'mdi-pencil' },
				{ name: 'delete', text: this.$i18n.translate('Delete'), icon: 'mdi-delete' }
			],
			selection: [],
			messageBox: {
				value: false,
				item: null,
				buttons: [
					{ name: 'DlgNo' },
					{ name: 'DlgYes', primary: true, color: 'primary' }
				]
			}
		}
	},
	listStoreName: 'depotsList-',
	computed: {
		...mapState({
			page (state) {
				return state[this.$options.listStoreName].page
			},
			data (state) {
				return state[this.$options.listStoreName].data
			},
			loading (state) {
				return state[this.$options.listStoreName].loading
			}
		}),
		totalPages () {
			return this.$store.getters[this.$options.listStoreName+'/totalPages']
		},
		currentPage: {
			get () {
				return this.page
			},
			set (v) {
				this.$store.dispatch(this.$options.listStoreName + '/setPage', v)
			}
		}
	},
	methods: {
		invokeAction ({ name, item }) {
			if (name === 'delete') {
				this.messageBox.text = item.name
				this.messageBox.item = item
				this.messageBox.value = true
			}

			if (name === 'default') {
				this.$refs.Dialog.init(item.id)
			}
		},
		deleteListItem (a) {
			if (a.name !== 'DlgYes') {
				this.$set(this.messageBox, 'value', false)
				return
			}

			this.$set(this.messageBox, 'loading', true)

			this.$store.dispatch(this.$options.listStoreName + '/deleteItem', this.messageBox.item).finally(() => {
				this.$set(this.messageBox, 'loading', false)
				this.$set(this.messageBox, 'value', false)
			})
		},
		createNewItem () {
			this.$refs.Dialog.init()
		},
		DialogData (data) {
			this.$store.commit(this.$options.listStoreName + '/updateItem', data)
		}
	},
	mounted () {
		const store = this.$store

		store.commit('core/appToolbar/resetToolbar')
		store.commit('core/appToolbar/setHeader', this.$i18n.translate('Depots'))

		store.dispatch(this.$options.listStoreName + '/load')
	},
	destroy () {
		this.$store.unregisterModule(this.$options.listStoreName)
	},
	created () {
		this.$store.commit(this.$options.listStoreName + '/setLimit', 100)
	},
	beforeCreate () {
		this.$options.listStoreName += this.uuid
		depotsStoreInit(this.$store, this.$options.listStoreName)
	},
	components: {
		Dialog
	}
}
</script>
